import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { GENDER_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddGenderForm from "./addGenderForm.component";
import GenderList from "./genderList.component";

const GenderConfig = () => {
  // const { auth } = useAuth();
  const [genderList, setGenderList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editGenderDetails, setEditGenderDetails] = useState({});
  const isEdit = Object.keys(editGenderDetails).length > 0 ? true : false;

  const getGenderList = async () => {
    try {
      const response = await axios.get(GENDER_CONFIG_URL);
      // console.log("Gender List", { response });
      response.status === 200 && setGenderList(response.data.genderList);
      response.status === 202 &&
        showToast("No gender entries found in the system.", "error");
    } catch (error) {
      console.error("getGenderList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getGenderList();
      setEditGenderDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Gender"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update Gender Details" : "Add Gender Details"}`}
        isAdd={true}
        clearData={setEditGenderDetails}
      >
        <AddGenderForm
          getGenderList={getGenderList}
          editGenderDetails={editGenderDetails}
          setEditGenderDetails={setEditGenderDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <GenderList
          genderList={genderList}
          getGenderList={getGenderList}
          setEditGenderDetails={setEditGenderDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default GenderConfig;
